export let decodeBase64 = (string) => {
	return atob(string);
}
export let getScrollBar = ()=>{
	let $html = document.documentElement;
	let isPage = document.querySelector("body").getAttribute("data-page");
	let scrollbarWidth 	= window.innerWidth - document.documentElement.clientWidth;
	let detailScrollbar = window.innerWidth - document.querySelector("main").clientWidth;
	let scrollbarW 		= Math.max(scrollbarWidth, detailScrollbar);
	if( scrollbarW === 0 && isPage != "philosophy" && !$html.classList.contains("mobile") ){
		setTimeout(function(){
			document.documentElement.style.setProperty('--scrollbar', ``);
			$html.classList.add("can_scroll");
			getScrollBar();
			$html.classList.remove("can_scroll");
		}, 100);
	}
	document.documentElement.style.setProperty('--scrollbar', `${scrollbarW}px`);
	//console.log(window.innerWidth, document.querySelector("main").clientWidth);
}
export let consoleInfo = (txt, result) => {
	console.log("%c" + txt,"color:white; background-color: #3AA6B9; padding:2px; border-radius:2px;", result);
}
export let stopPropagation = function(e){
	e.stopPropagation();
}
